import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { accountKeys } from '@/lib/query-keys';
import { financialService } from '@/services/financial.service';

export function useAccounts() {
  const queryClient = useQueryClient();

  const accountsQuery = useQuery({
    queryKey: accountKeys.list(),
    queryFn: () => financialService.getAccounts(),
  });

  const createAccount = useMutation({
    mutationFn: (data: Parameters<typeof financialService.createAccount>[0]) => financialService.createAccount(data),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: accountKeys.all }); toast.success('Account created'); },
    onError: () => toast.error('Failed to create account'),
  });

  const updateAccount = useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof financialService.updateAccount>[1] }) => financialService.updateAccount(id, data),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: accountKeys.all }); toast.success('Account updated'); },
    onError: () => toast.error('Failed to update account'),
  });

  const deleteAccount = useMutation({
    mutationFn: (id: string) => financialService.deleteAccount(id),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: accountKeys.all }); toast.success('Account deleted'); },
    onError: () => toast.error('Failed to delete account'),
  });

  return {
    accounts: accountsQuery.data?.data ?? [],
    isLoading: accountsQuery.isLoading,
    createAccount, updateAccount, deleteAccount,
  };
}
